define('shared/initializer/form/adapters/OffSitePayment',[
    './FramedForm',
    './mixins/OfferValidatable',
    './mixins/InvalidOfferPageLoadBlockable',
    './mixins/Redirectable',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/util/checkout/checkout'
],
function ( 
    Checkout, 
    OfferValidatable,
    InvalidOfferPageLoadBlockable,
    Redirectable,
    ctor, 
    RSVP, 
    console,
    checkoutUtil
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);
        me.mixin(
            OfferValidatable,
            InvalidOfferPageLoadBlockable,
            Redirectable
        );
    }).inherit(Checkout);

    var p = Ctor.prototype;

    p.doAfterSubmit = function( data ){
        console.log('OffSitePayment doBeforeRedirect received data:', data);

        if(data && data.Result){
            var orderId = data.Result;
            return checkoutUtil.handlePaymentSucceeded.call(this, orderId);
        }
        else{
            return RSVP.reject('Order id cannot be found');
        }
    };

    return Ctor;
});
